<div *ngIf="startSpinner">
    <span class="fa fa-spinner fa-pulse fa-2x fa-fw fa-align-center" aria-hidden="true"></span>
    {{'Loading... Please wait' | translate}} !
</div>